<template>
  <div class="row grabjob-view">
    <div class="col-md-12" v-for="serverStats in processStats">
      <server-stats :stats="serverStats" :process_id="processId" :key="serverStats._id"/>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import ServerStats from "./View/ServerStats";

export default {
  components: {ServerStats},
  async mounted () {
    const processId = this.$route.params.id;
    await this.serverFetchList();
    await this.processFetchStats(processId);
    await this.logbookFetchList(processId);
  },
  computed: {
    processId: function () {
      return this.$route.params.id;
    },
    processStats: function () {
      return this.statsByProcess()(this.processId);
    }
  },
  data: function () {
    return {};
  },
  methods: {
    ...mapActions(['serverFetchList', 'processFetchStats', 'logbookFetchList']),
    ...mapGetters(['statsByProcess']),

    // updateData: function () {
    //   this.chartData.setRo
    // }
  }
}
</script>
<style>
.card.card-transparent {
  background: transparent;
  box-shadow: none;
}

.card.card-transparent .card-footer {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GrabProcess/View.vue